import { useQuery } from "react-query";

import { getClinicianCaseloadSummary } from "api/clinician";
import { GET_CLINICIAN_CASELOAD_SUMMARY, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { queryParamsObjIsValid } from "utils/queryParamsObjIsValid";

interface CaseloadSummaryQuery {
  startDate?: string;
  endDate?: string;
  status?: string;
}

const useClinicianGetCaseloadSummary = (
  clinicianId: string | number | undefined,
  query: CaseloadSummaryQuery = {}
) => {
  const { data, isLoading, ...rest } = useQuery(
    [GET_CLINICIAN_CASELOAD_SUMMARY, clinicianId, query],
    () => getClinicianCaseloadSummary(clinicianId, query),
    {
      refetchOnWindowFocus: false,
      enabled: !!clinicianId && queryParamsObjIsValid(query),
      staleTime: STALE_TIME_5_MINUTES,
    }
  );

  return {
    caseloadSummary: (data as any)?.data || null,
    isCaseloadSummaryLoading: isLoading,
    ...rest,
  };
};

export default useClinicianGetCaseloadSummary;
